import request from '@/shared/api/request';

import type { DatabaseBackup } from '../../types';

export const convertDatabaseBackup = (
  database_uuid: string,
  backup_id: number,
): Promise<{ backup: DatabaseBackup }> =>
  request({
    url: `/databases/${database_uuid}/backups/${backup_id}/`,
    method: 'POST',
    data: { action: 'convert' },
  });
